/* BP instant — speculative prefetch of product/collection pages on intent (hover/touchstart).
   Makes taps feel instant: by the time the navigation starts, the HTML is already cached. */
(function () {
  if (window.__bpInstant) return;
  window.__bpInstant = true;

  /* respect data saver + very slow connections */
  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (/(^|-)2g/.test(conn.effectiveType || '')) return;

  var seen = new Set();
  var PATTERN = /\/(products|collections)\//;

  function prefetch(url) {
    if (seen.size > 60) return; /* cap memory/bandwidth */
    if (seen.has(url)) return;
    seen.add(url);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function candidate(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return null;
    if (a.origin !== location.origin) return null;
    var path = a.pathname;
    /* Tab-bar links are eligible whatever their path ('/', '/pages/deals', '/account'):
       on browsers without Speculation Rules (iOS) this touchstart prefetch is the whole
       head start the bottom tabs get, so they must not be filtered out by PATTERN. */
    var isTab = a.closest('.bp-mnav');
    if (!PATTERN.test(path) && !isTab) return null;
    if (path === location.pathname) return null;
    return a.href.split('#')[0];
  }

  /* touch: prefetch on touchstart (fires ~100ms+ before navigation) */
  document.addEventListener('touchstart', function (e) {
    var url = candidate(e);
    if (url) prefetch(url);
  }, { passive: true, capture: true });

  /* mouse: prefetch after 65ms of sustained hover */
  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var url = candidate(e);
    if (!url) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(url); }, 65);
  }, { passive: true, capture: true });
  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true, capture: true });

  /* ==========================================================================
     SPECULATION RULES — full prerender, not just prefetch.

     Prefetch only saves the network leg; the white "buffer" between pages is mostly
     parse + render. Speculation Rules prerender builds the whole page invisibly in the
     background, so activating it on tap is a ~0ms swap.

     Chromium-only by feature test. Safari lacks the API and silently keeps the touchstart
     prefetch above — nothing here may assume it ran.

     Two tiers:

     · Bottom tabs (mobile only) — eagerness: immediate. Three known destinations, pinned
       chrome; prerendering them up front is what makes the tabs read as one app.
       Document rules, not a URL list: the tabs are theme-editor blocks and the Deals tab
       resolves its own fallback URL server-side, so the links themselves are the source
       of truth. /account stays prefetch-only: it personalises and redirects to
       /account/login when logged out — a prerendered login snapshot is exactly the stale
       state we do not want to swap in.

     · Every product / collection link — eagerness: moderate. Chromium only starts the
       prerender when the user signals intent (touch-down, or ~200ms of hover), so the
       cost is one background load per link actually touched — and the tap that follows
       lands on an already-built page. This is what makes browsing card → product → back
       feel instant.

     Idle-deferred so the current page's own LCP always wins the bandwidth race.
     ========================================================================== */
  (function specRules() {
    if (typeof HTMLScriptElement === 'undefined' ||
        !HTMLScriptElement.supports ||
        !HTMLScriptElement.supports('speculationrules')) return;

    function inject() {
      /* A prerendered page must not fan out and prerender ITS neighbours — that would
         cascade loads. Wait until this document is the one on screen. */
      if (document.prerendering) {
        document.addEventListener('prerenderingchange', inject, { once: true });
        return;
      }

      var prerender = [];
      var prefetchRules = [];

      var mobile = window.matchMedia && matchMedia('(max-width: 1100px)').matches;
      if (mobile && document.querySelector('.bp-mnav')) {
        prerender.push({
          where: { and: [
            { selector_matches: '.bp-mnav__tab, .bp-mnav__logo' },
            { not: { selector_matches: "[href*='/account']" } },
            { not: { href_matches: location.pathname } }
          ] },
          eagerness: 'immediate'
        });
        prefetchRules.push({
          where: { selector_matches: ".bp-mnav__tab[href*='/account']" },
          eagerness: 'moderate'
        });
      }

      prerender.push({
        where: { and: [
          { href_matches: ['/products/*', '/collections/*'] },
          { not: { href_matches: location.pathname } }
        ] },
        eagerness: 'moderate'
      });

      var rules = { prerender: prerender };
      if (prefetchRules.length) rules.prefetch = prefetchRules;

      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.textContent = JSON.stringify(rules);
      document.head.appendChild(s);
    }

    function whenIdle() {
      if ('requestIdleCallback' in window) requestIdleCallback(inject, { timeout: 4000 });
      else setTimeout(inject, 2500);
    }
    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
  })();
})();
